import { lazy } from 'react';

export const AnalyticsDataSourceForm = lazy(
  () => import('./AnalyticsDataSourceForm'),
);
